module.exports = __webpack_public_path__ + "static/media/level3-1c.27c4eaaa.mp3";